const getDomain = () => {
	const env = document.location.hostname;
	let domain = '';

	switch (env) {
		case 'localhost':
			domain = 'http://localhost:3000'
			break
		case 'partner-test.roscolive.com':
			domain = 'https://test.roscolive.com'
			break
		case 'partner-dev.roscolive.com':
			domain = 'https://dev.roscolive.com'
			break
		case 'partner-stage.roscolive.com':
			domain = 'https://staging.roscolive.com'
			break
		case 'roscocloud.com':
		case 'www.roscocloud.com':
		case 'partner.roscolive.com':
			domain = 'https://fleet.roscolive.com'
			break
		default:
			break
	}

	return domain;
}

export function redirectToRoscoLive(argType, argCompanyId, argEntityId = null) {
	let url = `${getDomain()}/permalink/partner/${argType}/${argCompanyId}`
	if (argEntityId) {
		url += `/${argEntityId}`
	}
	url += `/${localStorage.getItem("s_t")}`
	window.location.assign(url)
}